const _defaultFont = {
  fontSize: 28,
  lineHeight: 34,
  fontFace: 'Regular',
};

const _colors = {
  Primary: 0xff2ea3f2,
  White: 0xffffffff,
  Transparent: 0x00000000,
  Black: 0xff000000,
  Red: 0xffff1133,
  Grey: 0xff757575,
  DarkGrey: 0xff303030,
  Secondary: 0xffb0ccec,
};

export const Theme = {
  Colors: {
    Transparent: _colors.Transparent,
    Primary: _colors.Primary,
    Secondary: _colors.Secondary,
    Black: _colors.Black,
    White: _colors.White,
    MiniDetail: {
      background: _colors.Primary,
    },
    Login: {
      Form: {
        background: 0x80000000,
      },
      Label: {
        focused: _colors.Primary,
        unfocused: 0xff949294,
        error: 0xffff7043,
      },
      Underline: {
        focused: _colors.Primary,
        unfocused: 0xffb7b6b8,
        error: 0xffff7043,
      },
      ShowPasswordIcon: {
        focused: 0x602ea3f2,
      },
    },
    InputFieldColors: {
      focused: 0xff245c83,
      unfocused: 0xff52626c,
    },
    Menu: {
      Normal: 0xff787878,
      Active: _colors.White,
    },
    ProfilePage: {
      Background: _colors.DarkGrey,
      InteractionUnfocused: 0xff1d2b34,
      InteractionFocused: 0xff245c83,
    },
    Ribbon: {
      Title: _colors.White,
      Card: {
        Focus: _colors.Primary,
        Unfocus: _colors.White,
        Background: 0x33111111,
        InfoBackground: _colors.Black,
        Text: {
          Normal: _colors.White,
          Highlight: _colors.Primary,
        },
        ScheduleLine: {
          Background: 0x99000000,
        },
      },
    },
    CmsProgress: {
      Unfilled: 0xff003c58,
      Filled: _colors.Primary,
    },
    CmsZappingBar: {
      CardPrimary: 0xff025d87,
      CardSecondary: 0xff183b58,
      CardBackground: 0xff00161f,
      Background: 0xff001119,
    },
    Banner: {
      DotBar: {
        selected: _colors.Primary,
        unselected: _colors.Grey,
        background: _colors.Black,
      },
    },
    Button: {
      Primary: {
        Normal: {
          Text: _colors.White,
          Border: _colors.White,
          Fill: _colors.Transparent,
        },
        Focus: {
          Text: _colors.Primary,
          Border: _colors.Primary,
          Fill: _colors.Transparent,
        },
      },
      Dialog: {
        Normal: {
          background: 0xff1d2b34,
          foreground: _colors.White,
        },
        Focus: {
          background: 0xff245c83,
          foreground: _colors.White,
        },
      },
      TextButton: {
        Normal: {
          Text: _colors.Grey,
          Fill: _colors.Transparent,
        },
        Focus: {
          Text: _colors.White,
          Border: _colors.White,
          Fill: _colors.Transparent,
        },
        Active: {
          Text: _colors.White,
          Fill: _colors.Transparent,
        },
      },
    },
    MessageDialog: {
      Background: 0xbb070707,
    },
    Keyboard: {
      Background: {
        unfocused: 0xff566267,
        focused: _colors.Primary,
      },
      Text: {
        unfocused: _colors.White,
        focused: _colors.White,
      },
    },
    SearchCompletion: {
      Bg: {
        unfocused: 0x33ffffff,
        focused: 0x400080df,
      },
      Text: {
        unfocused: _colors.white,
        focused: _colors.white,
      },
    },
    Option: {
      Background: {
        Page: 0xff070707,
        Item: 0xff1d2b34,
        Focus: 0xff245c83,
      },
      Text: {
        Normal: _colors.White,
        Focus: _colors.White,
        Selected: 0xff2ea3f2,
      },
    },
    Player: {
      Background: {
        Error: _colors.Black,
        TitleBar: 0x9a0000000,
        Seekbar: {
          Default: 0xff424242,
          Disabled: 0x88424242,
        },
      },
      Controls: {
        Seekbar: {
          Fill: {
            Disabled: 0xaaaaaaaa,
            Default: _colors.White,
            Focus: _colors.Primary,
          },
        },
        Buttons: {
          Disabled: _colors.Grey,
          Focus: _colors.Primary,
          Default: _colors.White,
        },
      },
    },
    Settings: {
      Header: 0xff2998e2,
      Background: {
        Normal: 0xff1d2b34,
        Focus: 0xff245c83,
      },
      Text: _colors.White,
    },
    Guide: {
      background: 0x2e2da2f1,
      programGradient: 0x60303030,
      divider: 0x33ffffff,
      currentTime: 0xffeb8000,
    },
  },
  Dimensions: {
    Menu: {
      contentOffset: 50,
    },
  },
  FontList: [
    { family: 'Regular', name: 'Roboto-Regular.ttf' },
    { family: 'Bold', name: 'Roboto-Bold.ttf' },
  ],
  Fonts: {
    Default: {
      fontFace: 'Regular',
    },
    Normal: {
      ..._defaultFont,
    },
    Bold: {
      ..._defaultFont,
      fontStyle: 'bold',
    },
    Login: {
      Label: {
        fontSize: 22,
        fontFace: 'Regular',
        //fontStyle: 'bold',
      },
    },
    MessageDialog: {
      Title: {
        fontFace: 'Regular',
        fontSize: 40,
        textAlign: 'center',
      },
      Message: {
        fontFace: 'Regular',
        fontSize: 30,
        textAlign: 'center',
      },
    },
    Banner: {
      Line1: {
        fontFace: 'Regular',
        textColor: 0xffde4097,
        fontSize: 32,
        shadow: true,
        wordWrapWidth: 800,
        maxLines: 1,
      },
      Line2: {
        fontFace: 'Regular',
        fontStyle: 'bold',
        fontSize: 44,
        shadow: true,
        wordWrapWidth: 800,
        maxLines: 1,
      },
      Line3: {
        fontFace: 'Regular',
        fontSize: 26,
        shadow: true,
        wordWrapWidth: 700,
        maxLines: 1,
      },
    },
    Settings: {
      Header: {
        fontFace: 'Regular',
        fontSize: 36,
      },
      Item: {
        fontFace: 'Regular',
        fontSize: 28,
      },
    },
    Option: {
      Title: {
        fontFace: 'Regular',
        fontSize: 40,
        textAlign: 'center',
      },
      Item: {
        fontFace: 'Regular',
        fontSize: 28,
        textAlign: 'center',
      },
    },
    CodeInput: {
      Title: {
        fontFace: 'Regular',
        fontSize: 40,
        textAlign: 'center',
      },
      ErrorMsg: {
        ..._defaultFont,
        textColor: _colors.Red,
      },
    },
    Ribbon: {
      Title: {
        fontFace: 'Regular',
        fontSize: 28,
        verticalAlign: 'middle',
        lineHeight: 50,
        iconSize: 36,
      },
      ScheduleLine: {
        fontFace: 'Regular',
        fontSize: 22,
        wordWrap: false,
        textOverflow: 'ellipsis',
        textAlign: 'center',
      },
      TopLine: {
        fontFace: 'Regular',
        fontSize: 24,
        lineHeight: 28,
        wordWrap: false,
        textOverflow: 'ellipsis',
      },
      BottomLine: {
        fontFace: 'Regular',
        fontSize: 20,
        lineHeight: 24,
        wordWrap: false,
        textOverflow: 'ellipsis',
      },
      FolderIconAmount: {
        fontFace: 'Regular',
        fontSize: 18,
        wordWrap: false,
      },
    },
    Detail: {
      Title: {
        ..._defaultFont,
        fontSize: 40,
        lineHeight: 62,
      },
      MetaInfo: {
        ..._defaultFont,
        textColor: _colors.Primary,
      },
      ExpireInfo: {
        ..._defaultFont,
        textColor: _colors.Primary,
      },
      Description: {
        ..._defaultFont,
      },
    },
    Player: {
      Error: {
        ..._defaultFont,
        fontSize: 34,
      },
      TitleBar: {
        Title: {
          ..._defaultFont,
          fontSize: 38,
        },
        Channel: {
          fontFace: 'Bold',
          fontSize: 28,
        },
        Separator: {
          ..._defaultFont,
          fontSize: 28,
        },
        MetaInfo: {
          ..._defaultFont,
          fontSize: 28,
        },
        Clock: {
          ..._defaultFont,
          fontSize: 28,
        },
      },
      Seekbar: {
        CurrentTime: {
          Font: {
            ..._defaultFont,
            fontSize: 28,
          },
          TextColor: {
            Default: _colors.White,
            Focus: _colors.Primary,
          },
        },
        RemainingTime: {
          ..._defaultFont,
          fontSize: 28,
        },
      },
      TrickPlayOverlay: {
        fontSize: 50,
        fontFace: 'Regular',
        textColor: _colors.White,
      },
    },
    Guide: {
      TimeLine: {
        ..._defaultFont,
        fontSize: 26,
      },
      ChannelNumber: {
        fontFace: 'Regular',
        fontSize: 36,
        textAlign: 'center',
      },
      ProgramTitle: {
        ..._defaultFont,
        fontSize: 30,
      },
      ProgramMeta: {
        ..._defaultFont,
        fontSize: 24,
      },
    },
  },
};
